/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

/**
 * SectionLabel — small coloured pill above section titles.
 */
export default function SectionLabel({ children }) {
  return (
    <span className="inline-block text-xs font-semibold tracking-widest uppercase bg-[#3B82F6]/15 text-[#60A5FA] px-3 py-1 rounded-full border border-[#3B82F6]/20 mb-4">
      {children}
    </span>
  );
}
